/* Field Watch 41 breakdown LP: variant and free strap picker, add to cart, sticky CTA, scroll reveals. */
(function () {
  'use strict';
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var setAll = function (sel, txt) { $$(sel).forEach(function (e) { e.textContent = txt; }); };

  function initOrder() {
    var root = document.querySelector('[data-fwb-order]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var gallery = [];
    try { gallery = JSON.parse(document.querySelector('[data-fwb-gallery]').textContent); } catch (e) {}
    var main = root.querySelector('[data-fwb-main]');
    var thumbs = root.querySelector('[data-fwb-thumbs]');
    var incl = root.querySelector('[data-fwb-incl]');
    var buy = root.querySelector('[data-fwb-buy]');
    var cards = $$('.fwb-var', root), straps = $$('.fwb-strap', root);
    var freeStrap = root.dataset.freeStrap === 'true';
    var cur = null, curStrap = null;

    function link() {
      if (!cur) return;
      buy.href = '/cart/' + cur.dataset.id + ':1' + (freeStrap && curStrap ? ',' + curStrap.dataset.id + ':1' : '');
    }
    function selectStrap(b) {
      curStrap = b;
      straps.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      setAll('[data-fwb-strap-was]', b.dataset.was);
      link();
    }

    function show(t) { main.src = t.img; main.alt = t.alt; }
    function buildThumbs(card) {
      var list = [{ img: card.dataset.img, alt: card.dataset.alt }];
      if (card.dataset.extra) list.push({ img: card.dataset.extra, alt: card.dataset.extraAlt });
      list = list.concat(gallery).slice(0, 5);
      thumbs.innerHTML = '';
      list.forEach(function (t, i) {
        var b = document.createElement('button');
        var im = document.createElement('img');
        b.type = 'button'; b.className = 'fwb-thumb'; b.setAttribute('aria-pressed', i === 0);
        im.src = t.img; im.alt = t.alt; b.appendChild(im);
        b.addEventListener('click', function () {
          show(t);
          $$('.fwb-thumb', thumbs).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        });
        thumbs.appendChild(b);
      });
    }
    function select(card) {
      cur = card;
      cards.forEach(function (c) { c.setAttribute('aria-pressed', c === card); });
      show({ img: card.dataset.img, alt: card.dataset.alt });
      buildThumbs(card);
      incl.textContent = '';
      incl.classList.remove('fwb-on');
      if (card.dataset.extra) {
        var h = document.createElement('b');
        h.textContent = "What's included";
        incl.appendChild(h);
        incl.appendChild(document.createTextNode(card.dataset.incl));
        incl.classList.add('fwb-on');
      }
      setAll('[data-fwb-now]', card.dataset.now);
      setAll('[data-fwb-was]', card.dataset.was);
      setAll('[data-fwb-btn]', card.dataset.now);
      link();
    }
    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    straps.forEach(function (b) { b.addEventListener('click', function () { selectStrap(b); }); });
    if (straps.length) selectStrap(straps[0]);
    var first = cards.filter(function (c) { return !c.disabled; })[0];
    if (first) select(first);

    buy.addEventListener('click', function (e) {
      if (!cur || !window.fetch) return;
      e.preventDefault();
      var href = buy.href, items = [{ id: parseInt(cur.dataset.id, 10), quantity: 1 }];
      if (freeStrap && curStrap) items.push({ id: parseInt(curStrap.dataset.id, 10), quantity: 1 });
      buy.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        buy.removeAttribute('aria-busy');
        try {
          if (window.upcartOpenCart) window.upcartOpenCart();
          else if (window.upcart && typeof window.upcart.openCart === 'function') window.upcart.openCart();
          else document.dispatchEvent(new CustomEvent('upcart:open'));
        } catch (err) {}
      }).catch(function () { window.location.href = href; });
    });
  }

  function initSticky() {
    var sticky = document.querySelector('[data-fwb-sticky]');
    var mast = document.getElementById('top');
    var order = document.getElementById('order');
    if (!sticky || !mast || !order || !('IntersectionObserver' in window)) return;
    var mastVisible = true, orderVisible = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.target === mast) mastVisible = e.isIntersecting;
        if (e.target === order) orderVisible = e.isIntersecting;
      });
      sticky.classList.toggle('fwb-on', !mastVisible && !orderVisible);
    }, { threshold: 0.05 });
    io.observe(mast); io.observe(order);
  }

  function initReveal() {
    if (window.Shopify && Shopify.designMode) return; /* never hide content in the theme editor */
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var groups = ['.fwb-sec-head', '.fwb-qa-head', '.fwb-trans .fwb-row', '.fwb-num', '.fwb-field figure', '.fwb-chk-head', '.fwb-ticks li', '.fwb-item .fwb-no', '.fwb-item .fwb-txt', '.fwb-item figure', '.fwb-col', '.fwb-tow', '.fwb-own-main', '.fwb-revs .fwb-r', '.fwb-ways .fwb-c', '.fwb-order .fwb-pic', '.fwb-card', '.fwb-faq details', '.fwb-close .fwb-wrap > *'];
    var seen = [];
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fwb-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    groups.forEach(function (sel) {
      var i = 0;
      $$(sel).forEach(function (el) {
        if (seen.indexOf(el) > -1) return;
        seen.push(el);
        el.classList.add('fwb-reveal');
        el.style.setProperty('--d', Math.min(i * 70, 420) + 'ms');
        i++;
        io.observe(el);
      });
    });
  }

  function init() { initOrder(); initSticky(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', initOrder);
})();
